export default __webpack_public_path__ + "static/media/step-done.39d84019.png";